import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent, memo } from 'react';
import { noop } from 'shell/utils/noop';

interface SimaSubMenuNascitaProps {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
  value: string;
  onClickNuovo: () => void;
  onClickIcaro?: () => void;
  onClickRicerca: () => void;
  onClickRicercaSima: () => void;
  onClickComunicazioniLista: () => void;
  onClickComunicazioni: () => void;
  onClickRegistrationSC: () => void;
  onClickReportistica: () => void;
  onClickAnnotazioni: () => void;
  onClickRichiestaNumero: () => void;
  onClickRicercaNumero: () => void;
  withoutIcaro?: boolean;
  anscCommunication?: boolean;
  anscReport?: boolean;
}

const SimaSubMenuNewComponent = ({
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
  value,
  onClickNuovo,
  onClickIcaro = noop,
  // onClickRicerca,
  // onClickRicercaSima,
  onClickComunicazioniLista,
  onClickComunicazioni,
  onClickRegistrationSC,
  onClickReportistica,
  onClickRichiestaNumero,
  withoutIcaro = false,
  anscCommunication = false,
  anscReport = false,
}: SimaSubMenuNascitaProps): React.ReactElement => {
  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary={value} />
      </ListItem>
      <Menu
        id={`${value}-menu`}
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        <MenuItem
          key="Stesura-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickNuovo();
          }}
        >
          <Typography variant="inherit">Stesura nuovo evento</Typography>
        </MenuItem>
        <Divider key="Stesura-divider" />
        {withoutIcaro ? undefined : (
          <Fragment>
            <MenuItem
              key="Icaro-menu-item"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();

                onClose(event);
                onClickIcaro();
              }}
            >
              <Typography variant="inherit">Dichiarazioni di nascita (ICARO)</Typography>
            </MenuItem>
            <Divider key="Icaro-divider" />
          </Fragment>
        )}
        {/* <MenuItem
          key="Ricerca-sima-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickRicercaSima();
          }}
        >
          <Typography variant="inherit">Ricerca atti SIMA</Typography>
        </MenuItem>
        <Divider key="Ricerca-sima-divider" />
        <MenuItem
          key="Ricerca-ansc-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickRicerca();
          }}
        >
          <Typography variant="inherit">Ricerca atti ANSC</Typography>
        </MenuItem>
        <Divider key="Ricerca-ansc-divider" /> */}
        <MenuItem
          style={{ whiteSpace: 'unset' }}
          key="Richiesta-numero-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickRichiestaNumero();
          }}
        >
          <Typography variant="inherit">Gestione della numerazione comunale</Typography>
        </MenuItem>
        <Divider key="Richiesta-numero-divider" />
        {/* <MenuItem
          style={{ whiteSpace: 'unset' }}
          key="Ricerca-numero-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickRicercaNumero();
          }}
        >
          <Typography variant="inherit">
            Gestione della numerazione comunale - Ricerca e consultazione
          </Typography>
        </MenuItem>
        <Divider key="notifiche-divider" /> */}
        {/* <MenuItem
          style={{ whiteSpace: 'unset' }}
          key="notifiche-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickNotifiche();
          }}
        >
          <Typography variant="inherit">Notifiche</Typography>
        </MenuItem>
        <Divider key="Ricerca-notifiche-divider" /> */}
        {anscCommunication ? (
          <Fragment>
            <MenuItem
              key="Comunicazioni-da-lista-menu-item"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();

                onClose(event);
                onClickComunicazioniLista();
              }}
            >
              <Typography variant="inherit">Comunicazioni da Lista</Typography>
            </MenuItem>
            <Divider key="com-da-atto-divider" />
          </Fragment>
        ) : undefined}
        {anscCommunication ? (
          <Fragment>
            <MenuItem
              key="Comunicazioni-da-atto-menu-item"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();

                onClose(event);
                onClickComunicazioni();
              }}
            >
              <Typography variant="inherit">Comunicazioni da Atto</Typography>
            </MenuItem>
            <Divider key="Scarico-divider" />
          </Fragment>
        ) : undefined}
        <MenuItem
          key="Scarico-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickRegistrationSC();
          }}
        >
          <Typography variant="inherit">Registrazione SC - ANAGRAFE</Typography>
        </MenuItem>
        <Divider key="Scarico-divider" />
        {anscReport ? (
          <Fragment>
            <MenuItem
              key="Reportistica-menu-item"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                event.nativeEvent.stopImmediatePropagation();

                onClose(event);
                onClickReportistica();
              }}
            >
              <Typography variant="inherit">Reportistica</Typography>
            </MenuItem>
            {/* <Divider key="Reportistica-divider" /> */}
          </Fragment>
        ) : undefined}
        {/* <MenuItem
          key="Annotazioni-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();

            onClose(event);
            onClickAnnotazioni();
          }}
        >
          <Typography variant="inherit">Annotazioni</Typography>
        </MenuItem> */}
      </Menu>
    </Fragment>
  );
};

SimaSubMenuNewComponent.displayName = 'Sima Sub Menu new';

const SimaSubMenuNew = memo(SimaSubMenuNewComponent);

export default SimaSubMenuNew;
